// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.benefitCard {
  border-radius: 2.7972027972vh;
  width: 100%;
  min-height: 30vh;
  padding: 1rem;
  border: none !important;
  font-weight: 400;
  background-color: #1D1A36;
}

.textNucleusteqs {
  color: #FFF;
  padding: 2vh;
  text-align: center;
  font-family: Roboto;
  font-size: 1.5vw;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-top: 50px;
}

.benefitIconCol {
  display: flex;
  justify-content: center;
  margin-bottom: 2vh;
}

.imageIconBenefit {
  width: 5vw;
}

.benefitCardHeading1 {
  font-weight: 700;
  font-size: 3.3566433566vh;
  color: var(--orange-0, #F0592A);
}

.benefitCardPtag {
  font-weight: 400;
  font-size: 2.5174825175vh;
  color: #FFFFFF;
  line-height: 3.5vh;
}

@media (max-width: 1440px) {
  .benefitCard {
    min-height: 34vh;
  }
}
@media (max-width: 1024px) {
  .benefitCard {
    min-height: 41vh;
  }
}
@media (max-width: 990px) {
  .benefitCard {
    min-height: 23vh;
  }
  .imageIconBenefit {
    width: 10vw;
  }
  .benefitCardHeading1 {
    font-size: 3vh;
  }
  .benefitCardPtag {
    font-size: 2vh;
  }
}
@media (max-width: 425px) {
  .benefitCard {
    min-height: 48vh;
  }
}
@media (max-width: 1200px) {
  .textNucleusteqs {
    font-size: 2vw;
  }
}
@media (max-width: 992px) {
  .textNucleusteqs {
    font-size: 2vw;
  }
}
@media (max-width: 768px) {
  .textNucleusteqs {
    font-size: 2.3vw;
  }
}
@media (max-width: 576px) {
  .textNucleusteqs {
    font-size: 4vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/BenefitCards/benefitCards.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AACJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;AAAJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,gBAAA;EACA,yBAAA;EACA,+BAAA;AADJ;;AAIA;EACI,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AADJ;;AAIA;EACI;IACI,gBAAA;EADN;AACF;AAIA;EACI;IACI,gBAAA;EAFN;AACF;AAKA;EACI;IACI,gBAAA;EAHN;EAME;IACI,WAAA;EAJN;EAOE;IACI,cAAA;EALN;EAQE;IACI,cAAA;EANN;AACF;AAUA;EACI;IACI,gBAAA;EARN;AACF;AAYA;EACI;IACI,cAAA;EAVN;AACF;AAaA;EACI;IACI,cAAA;EAXN;AACF;AAcA;EACI;IACI,gBAAA;EAZN;AACF;AAeA;EACI;IACI,cAAA;EAbN;AACF","sourcesContent":[".benefitCard {\n    border-radius: 2.797202797202797vh;\n    width: 100%;\n    min-height: 30vh;\n    padding: 1rem;\n    border: none !important;\n    font-weight: 400;\n    background-color: #1D1A36;\n    \n}\n\n.textNucleusteqs {\n    color: #FFF;\n    padding: 2vh;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 1.5vw;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n    margin-top: 50px;\n}\n\n.benefitIconCol {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 2vh;\n\n}\n\n.imageIconBenefit {\n    width: 5vw;\n}\n\n.benefitCardHeading1 {\n    font-weight: 700;\n    font-size: 3.3566433566433567vh;\n    color: var(--orange-0, #F0592A);\n}\n\n.benefitCardPtag {\n    font-weight: 400;\n    font-size: 2.5174825174825175vh;\n    color: #FFFFFF;\n    line-height: 3.5vh;\n}\n\n@media (max-width: 1440px) {\n    .benefitCard {\n        min-height: 34vh;\n    }\n}\n\n@media (max-width: 1024px) {\n    .benefitCard {\n        min-height: 41vh;\n    }\n}\n\n@media (max-width: 990px) {\n    .benefitCard {\n        min-height: 23vh;\n    }\n\n    .imageIconBenefit {\n        width: 10vw;\n    }\n\n    .benefitCardHeading1 {\n        font-size: 3vh;\n    }\n\n    .benefitCardPtag {\n        font-size: 2vh;\n\n    }\n}\n\n@media (max-width: 425px) {\n    .benefitCard {\n        min-height: 48vh;\n    }\n}\n\n\n@media (max-width: 1200px) {\n    .textNucleusteqs {\n        font-size: 2vw;\n    }\n}\n\n@media (max-width: 992px) {\n    .textNucleusteqs {\n        font-size: 2vw;\n    }\n}\n\n@media (max-width: 768px) {\n    .textNucleusteqs {\n        font-size: 2.3vw;\n    }\n}\n\n@media (max-width: 576px) {\n    .textNucleusteqs {\n        font-size: 4vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
